import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiX, FiCornerUpLeft, FiEdit2 } from "react-icons/fi";
import { clearReplyingTo, clearEditingMessage } from "../../../Slices/chatSlice";

const ReplyPreview = () => {
  const dispatch = useDispatch();
  const replyingTo = useSelector((state) => state.chat.replyingTo);
  const editingMessage = useSelector((state) => state.chat.editingMessage);

  if (!replyingTo && !editingMessage) return null;

  const isEditing = !!editingMessage;

  const handleClose = () => {
    if (isEditing) {
      dispatch(clearEditingMessage());
    } else {
      dispatch(clearReplyingTo());
    }
  };

  return (
    <div className="reply-preview">
      <div className="reply-preview__icon">
        {isEditing ? <FiEdit2 size={14} /> : <FiCornerUpLeft size={14} />}
      </div>
      <div className="reply-preview__content">
        <div className="reply-preview__label">
          {isEditing ? "Editing message" : `Replying to ${replyingTo.senderName}`}
        </div>
        <div className="reply-preview__text">
          {isEditing ? editingMessage.content : replyingTo.content}
        </div>
      </div>
      <button className="reply-preview__close" onClick={handleClose} type="button">
        <FiX size={16} />
      </button>
    </div>
  );
};

export default ReplyPreview;
